var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.678 7.324 16 3.73 7.322 7.324l-3.594 8.678 3.594 8.678L16 28.275l8.678-3.595 3.594-8.678-3.594-8.678zM15.55 1.089a1.18 1.18 0 0 1 .9 0l9.775 4.05c.288.119.516.347.636.635l4.05 9.775c.12.288.12.611 0 .9l-4.05 9.775a1.173 1.173 0 0 1-.635.635l-9.776 4.05a1.168 1.168 0 0 1-.9 0l-9.775-4.05a1.172 1.172 0 0 1-.636-.635l-4.05-9.776a1.175 1.175 0 0 1 0-.9l4.05-9.775a1.174 1.174 0 0 1 .635-.636l9.775-4.05zm5.304 18.765h-5.806l3.647-4.016-3.524-3.692h5.684V9.451h-9.69v2.46l3.802 3.962-3.82 4.23v2.451h9.708v-2.698z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErg);
export default __webpack_public_path__ + "static/media/ERG.8c1748ae3b3fa604b1bd16c9767458a0.svg";
export { ForwardRef as ReactComponent };